import { render, staticRenderFns } from "./topicDetails.vue?vue&type=template&id=7efa93dc&scoped=true&"
import script from "./topicDetails.vue?vue&type=script&lang=js&"
export * from "./topicDetails.vue?vue&type=script&lang=js&"
import style0 from "./topicDetails.vue?vue&type=style&index=0&id=7efa93dc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7efa93dc",
  null
  
)

export default component.exports